/* Extracted from snippets/circle-cart-points.liquid (lines 225-581 of the 20 Oct 2026 live copy) by checks/split_inline_js.py.
   Same code, same position in the page; now a cached asset instead of inline HTML. */
      (function () {
        if (window.__tcCircleBanner) return;
        window.__tcCircleBanner = true;
        var TC_FF_END = 1792972740000;
        document.addEventListener('cart:updated', function (e) {
          var cart = e && e.detail && e.detail.cart;
          if (!cart) return;
          var total = Number(cart.total_price) || 0;
          var hasSub = false;
          var hasOneOff = false;
          (cart.items || []).forEach(function (i) {
            if (!i) return;
            if (i.gift_card) total -= Number(i.final_line_price) || 0;
            if (i.selling_plan_allocation) hasSub = true;
            else if (!i.gift_card) hasOneOff = true;
          });
          if (total < 0) total = 0;
          var ff = Date.now() < TC_FF_END;
          /* Zero friction (18 Oct): 15% already on (FIRST15 / WELCOME15) → no join row,
             unless the shopper has just joined here (their confirmation stays).
             Google seamless (18 Oct night): nor while another code applies.
             FIRST15 on the website (19 Oct): WELCOME15 counts only while it works
             (it applies, or nothing one-off is in yet), so a switched-off
             WELCOME15 brings the row back. */
          var firstOn = (cart.discount_codes || []).some(function (d) {
            var k = String((d && d.code) || '').toUpperCase();
            return k === 'FIRST15' || !!(d && d.applicable) || (k === 'WELCOME15' && !hasOneOff);
          });
          document.querySelectorAll('[data-circle-banner]').forEach(function (el) {
            var base = parseInt(el.getAttribute('data-rate'), 10) || 1;
            var n = Math.floor(total / 100) * (ff ? 2 : base);
            var guest = el.hasAttribute('data-cb-guest');
            var show = cart.item_count > 0 && (guest ? (hasOneOff && (!firstOn || el.hasAttribute('data-cb-just-joined'))) : (hasSub || n > 0));
            el.hidden = !show;
            if (!show) return;
            var earn = el.querySelector('[data-cb-earn]');
            var subs = el.querySelector('[data-cb-subs]');
            if (earn) earn.hidden = guest ? !hasOneOff : hasSub;
            if (subs) subs.hidden = !hasSub;
            /* Mixed basket: say plainly that the one-off items earn nothing either (pipeline audit, 13 Oct). */
            var subsOnly = el.querySelector('[data-cb-subs-only]');
            var subsMixed = el.querySelector('[data-cb-subs-mixed]');
            if (subsOnly) subsOnly.hidden = hasOneOff;
            if (subsMixed) subsMixed.hidden = !hasOneOff;
            var line = el.querySelector('[data-cb-line]');
            var text = 'This order earns ' + n + (ff ? '' : ' Circle') + (n === 1 ? ' point' : ' points') +
              (ff ? ', double until Sun 25 Oct' : '');
            if (line && line.textContent !== text) line.textContent = text;
          });
        });
      })();
      /* Welcome 15, sharper (18 Oct 2026 evening): the basket's join row.
         Same steps as the pop-up (holiday-notice.liquid): a valid email fires
         /discount/FIRST15?redirect=%2Fcart.js (WELCOME15 until 19 Oct 2026)
         AND the customer form POST at
         the same time; as soon as the code is on, the row says
         "✓ 15% off is on — saving £X" (from the returned cart), the basket
         repaints (TheColor.Cart.init) and tc:welcome15 fires. Never replaces
         a code already on the basket (a WELCOME15 that still works counts as
         the same 15%).
         Captcha (the sign-up wasn't accepted): the 15% stays on and a
         "Confirm my email" button runs a real customer form (Shopify adds
         its challenge); holiday-notice's head snippet then returns to /cart.
         Delegated, because the drawer re-renders. */
      (function () {
        if (window.__tcW15Cart) return;
        window.__tcW15Cart = true;
        var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        var BAD = 'Please enter a full email, e.g. name@example.com.';
        var TAGS = 'newsletter,basket,welcome15';
        function joined() { return /(?:^|; )tc_subscribed=1(?:;|$)/.test(document.cookie); }
        function setJoined() { document.cookie = 'tc_subscribed=1; path=/; max-age=31536000; SameSite=Lax; Secure'; }
        function up(s) { return String(s || '').toUpperCase(); }
        function money(p) {
          var u = window.TheColor && window.TheColor.utils;
          if (u && typeof u.formatMoney === 'function') { try { return u.formatMoney(p); } catch (e) {} }
          return '£' + (p / 100).toFixed(2);
        }
        function capped(ms) {
          var c = null;
          try { c = new AbortController(); } catch (e) {}
          var t = setTimeout(function () { if (c) c.abort(); }, ms);
          return { signal: c ? c.signal : undefined, done: function () { clearTimeout(t); } };
        }
        /* FIRST15, or WELCOME15 while it works (19 Oct: it applies, or nothing one-off is in yet). */
        function welcomeOf(c) {
          var oneOffIn = ((c && c.items) || []).some(function (i) { return i && !i.selling_plan_allocation && !i.gift_card; });
          var w = ((c && c.discount_codes) || []).filter(function (d) { var k = up(d && d.code); return k === 'FIRST15' || (k === 'WELCOME15' && (!!d.applicable || !oneOffIn)); })
            .sort(function (a, b) { return (b.applicable ? 2 : 0) + (up(b.code) === 'FIRST15' ? 1 : 0) - (a.applicable ? 2 : 0) - (up(a.code) === 'FIRST15' ? 1 : 0); });
          return w.length ? up(w[0].code) : null;
        }
        function otherOf(c) {
          var o = ((c && c.discount_codes) || []).filter(function (d) { var k = up(d && d.code); return k && k !== 'WELCOME15' && k !== 'FIRST15'; });
          return o.length ? String(o[0].code) : null;
        }
        function savingOf(c, code) {
          var sum = 0;
          (c.cart_level_discount_applications || []).forEach(function (a) { if (a && up(a.title || a.code) === code) sum += +a.total_allocated_amount || 0; });
          if (!sum) {
            (c.items || []).forEach(function (i) {
              ((i && i.line_level_discount_allocations) || []).forEach(function (d) {
                var app = d && d.discount_application;
                if (app && up(app.title || app.code) === code) sum += +d.amount || 0;
              });
            });
          }
          return sum;
        }

        var st = null;          /* { state: 'on' | 'kept', code, other } once joined here */
        var signupOk = null;    /* false = the sign-up needs the email confirmed (captcha) */
        var lastEmail = '';
        var lastCart = null;    /* the newest cart from cart:updated */
        var lastAt = 0;

        function line(c) {
          if (!st) return '';
          if (st.state === 'kept') return '✓ Your basket already has ' + st.other + ', so we’ve kept it. FIRST15 is yours too: use it at checkout instead if it saves you more.';
          var code = st.code || 'FIRST15';
          if (!c) return '✓ 15% off is on. It comes off at checkout.';
          var on = (c.discount_codes || []).some(function (d) { return d && up(d.code) === code && d.applicable; });
          if (on) { var s = savingOf(c, code); return s > 0 ? '✓ 15% off is on — saving ' + money(s) : '✓ 15% off is on. It comes off at checkout.'; }
          /* One code (19 Oct 2026): no minimum any more, so no "reaches £20 … to go" line. */
          return '✓ 15% off is on. It comes off at checkout.';
        }
        function paint(c) {
          var j = joined();
          document.querySelectorAll('[data-cb-w15]').forEach(function (g) {
            g.hidden = !!st;
            g.classList.toggle('is-joined', j);
            var b = g.querySelector('[data-cb-w15-go]');
            if (b && g.getAttribute('aria-busy') !== 'true') b.textContent = j ? 'Add 15% off' : 'Get 15% off';
          });
          var text = line(c);
          document.querySelectorAll('[data-cb-w15-done]').forEach(function (p) { if (p.textContent !== text) p.textContent = text; });
          document.querySelectorAll('[data-cb-w15-confirm]').forEach(function (p) { p.hidden = !(st && signupOk === false && lastEmail); });
        }
        try { if (location.pathname === '/cart' && sessionStorage.getItem('tc_w15_ok') === '1') sessionStorage.removeItem('tc_w15_ok'); } catch (e) {}
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(lastCart); }, { once: true }); else paint(lastCart);
        document.addEventListener('cart:updated', function (e) {
          var c = e && e.detail && e.detail.cart;
          if (c && Array.isArray(c.discount_codes)) { lastCart = c; lastAt = Date.now(); }
          setTimeout(function () { paint(lastCart); }, 0);
        });
        document.addEventListener('tc:welcome15', function (e) {
          /* Joined from the basket just now: keep its confirmation line on screen. */
          if (e && e.detail && e.detail.from === 'basket') {
            document.querySelectorAll('[data-circle-banner][data-cb-guest]').forEach(function (el) { el.setAttribute('data-cb-just-joined', ''); });
          }
          paint(lastCart);
        });
        function say(g, t) {
          var m = g.querySelector('[data-cb-w15-msg]');
          var i = g.querySelector('[data-cb-w15-email]');
          if (m) m.textContent = t || '';
          if (i) i.setAttribute('aria-invalid', t ? 'true' : 'false');
        }
        function json(url, ms) {
          var t = capped(ms);
          return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, redirect: 'follow', signal: t.signal })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c) { t.done(); return c && Array.isArray(c.discount_codes) ? c : null; })
            .catch(function () { t.done(); return null; });
        }
        /* The basket state: the theme's own last render if it's fresh, else /cart.js. */
        function cartNow() {
          if (lastCart && Date.now() - lastAt < 60000) return Promise.resolve(lastCart);
          return json('/cart.js', 2500);
        }
        /* → { state: 'on' | 'kept' | 'failed', code, other, cart } */
        function codeFlow() {
          return cartNow().then(function (c) {
            var w = welcomeOf(c);
            if (w) return { state: 'on', code: w, cart: c };
            var o = otherOf(c);
            if (o) return { state: 'kept', other: o, cart: c };
            return json('/discount/FIRST15?redirect=%2Fcart.js', 5000).then(function (a) {
              var w2 = welcomeOf(a);
              return w2 ? { state: 'on', code: w2, cart: a, added: true } : { state: 'failed' };
            });
          });
        }

        /* 21 Oct 2026: sign-up guard. Bots over Tor exit nodes were posting
           fake addresses (dotted-Gmail aliases, random business domains) into
           the sign-up. Before any Klaviyo or /contact call: honeypot empty,
           a trusted pointer/keyboard event has happened, 2.5 s since the
           script ran, no Gmail alias with 3+ dots, no disposable domain. A
           failed guard shows the normal thank-you and sends nothing. */
        var TC_GUARD = (function () {
          var t0 = Date.now(), human = false;
          var mark = function (ev) { if (ev && ev.isTrusted) human = true; };
          ['pointerdown', 'keydown', 'touchstart'].forEach(function (n) { try { document.addEventListener(n, mark, { capture: true, passive: true }); } catch (e) { document.addEventListener(n, mark, true); } });
          var DISPOSABLE = /@(mailinator|guerrillamail|10minutemail|temp-?mail|yopmail|sharklasers|trashmail|getnada|dispostable|maildrop|throwawaymail|fakeinbox|mohmal|tempr|emailondeck|mintemail)\./i;
          return function (email, form) {
            var hp = form && form.querySelector ? form.querySelector('input[name="tc_website"]') : null;
            if (hp && hp.value) return 'honeypot';
            if (!human) return 'no-interaction';
            if (Date.now() - t0 < 2500) return 'too-fast';
            var m = /^([^@]+)@(.+)$/.exec(String(email || '').trim());
            if (!m) return 'email';
            var local = m[1], dom = m[2].toLowerCase();
            if (/^(gmail|googlemail)\.com$/.test(dom) && local.split('.').length - 1 >= 3) return 'dotted-gmail';
            if (DISPOSABLE.test('@' + dom)) return 'disposable';
            return '';
          };
        })();
        function subscribe(email, source, form) {
          var whyBlocked = TC_GUARD(email, form || (document.querySelector('[data-cb-w15-email]') || {}).form);
          if (whyBlocked) return Promise.resolve(true);
          var body = new URLSearchParams();
          body.append('form_type', 'customer');
          body.append('utf8', '✓');
          body.append('contact[email]', email);
          body.append('contact[accepts_marketing]', 'true');
          body.append('contact[tags]', TAGS);
          var t = capped(4000);
          var shop = fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow', signal: t.signal })
            .then(function (r) { t.done(); var u = r.url || ''; return u.indexOf('/challenge') === -1 && /[?&]customer_posted=true/.test(u); })
            .catch(function () { t.done(); return false; });
          /* 19 Oct 2026: Shopify's captcha turns the /contact post away for
             most shoppers, which left them off the mailing list. Klaviyo is
             now the sign-up; /contact still runs alongside for the Shopify
             record. Either one landing counts as joined. */
          return firstTrue([klaviyoSub(email, source), shop]);
        }
        /* Klaviyo sign-up: public client endpoint (company id only, no key),
           single opt-in "Email List" Y6RS7f (starts the Welcome flow).
           202 = joined. When marketing cookies are allowed, the browser is
           also identified, so basket reminders can reach them. */
        function klaviyoSub(email, source) {
          if (!window.fetch || !window.JSON) return Promise.resolve(false);
          var t = capped(6000);
          var payload = { data: { type: 'subscription', attributes: { custom_source: source || 'Basket FIRST15', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: 'Y6RS7f' } } } } };
          return fetch('https://a.klaviyo.com/client/subscriptions?company_id=SKBdJj', { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(payload), signal: t.signal })
            .then(function (r) {
              t.done();
              var ok = r.status >= 200 && r.status < 300;
              if (ok) {
                try {
                  var cp = window.Shopify && window.Shopify.customerPrivacy;
                  var k = window.klaviyo;
                  if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() && k && typeof k.identify === 'function') {
                    var p = k.identify({ email: email });
                    if (p && typeof p.catch === 'function') p.catch(function () {});
                  }
                } catch (e) {}
              }
              return ok;
            })
            .catch(function () { t.done(); return false; });
        }
        /* true as soon as any promise gives true; false once all have settled
           without one. (The promises here never reject.) */
        function firstTrue(list) {
          return new Promise(function (resolve) {
            var left = list.length;
            list.forEach(function (p) {
              p.then(function (ok) { if (ok) resolve(true); else if (--left === 0) resolve(false); }, function () { if (--left === 0) resolve(false); });
            });
          });
        }
        /* 24 Oct 2026: the same sign-up for the "15% is on" row (below), with its own source. */
        window.__tcCbSubscribe = subscribe;
        /* Captcha path: a real Shopify customer form, built at the end of
           <body> (never inside the cart form), so Shopify can add its
           challenge; holiday-notice's head snippet then returns to /cart
           (adding the code on the way only when it isn't on yet). */
        function realPost(email, next) {
          try { next.t = Date.now(); sessionStorage.setItem('tc_w15_next', JSON.stringify(next)); } catch (err) {}
          var f = document.createElement('form');
          f.method = 'post';
          f.action = '/contact#tc-cb-w15';
          f.hidden = true;
          [['form_type', 'customer'], ['utf8', '✓'], ['contact[email]', email], ['contact[accepts_marketing]', 'true'], ['contact[tags]', TAGS]].forEach(function (p) {
            var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; f.appendChild(i);
          });
          document.body.appendChild(f);
          try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (err) { f.submit(); }
        }
        /* /cart re-renders its whole section from the server once the total
           changes (sections/cart-main.liquid swapSection), which brings the row
           back hidden (the code is on now) and without this visit's "just
           joined" mark, so the confirmation and any "Confirm my email" row
           vanished ~0.2 s after showing (UX review, 18 Oct). Put them back
           after each swap; only watches the section's own children. */
        var swapObs = null;
        function keepAfterSwap() {
          var main = document.querySelector('[data-section-type="cart-main"]');
          if (swapObs || !main || !window.MutationObserver) return;
          swapObs = new MutationObserver(function () {
            if (!st) return;
            var c = lastCart;
            var oneOff = !!c && (c.items || []).some(function (i) { return i && !i.selling_plan_allocation && !i.gift_card; });
            main.querySelectorAll('[data-circle-banner][data-cb-guest]:not([data-cb-just-joined])').forEach(function (el) {
              el.setAttribute('data-cb-just-joined', '');
              if (c && c.item_count > 0 && oneOff) {
                el.hidden = false;
                var earn = el.querySelector('[data-cb-earn]');
                if (earn) earn.hidden = false;
              }
            });
            paint(lastCart);
          });
          swapObs.observe(main, { childList: true });
        }
        function busy(g, on) {
          var b = g.querySelector('[data-cb-w15-go]');
          var i = g.querySelector('[data-cb-w15-email]');
          if (on) { g.setAttribute('aria-busy', 'true'); if (b) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…'; } if (i) i.readOnly = true; return; }
          g.removeAttribute('aria-busy');
          if (b) b.removeAttribute('aria-busy');
          if (i) i.readOnly = false;
        }
        function join(g) {
          if (g.getAttribute('aria-busy') === 'true') return;
          var input = g.querySelector('[data-cb-w15-email]');
          var already = joined();
          var email = input ? input.value.trim() : '';
          if (!already && !RE.test(email)) { say(g, BAD); if (input) input.focus(); return; }
          say(g, '');
          var CODE_URL = '/discount/FIRST15?redirect=%2Fcart';
          if (!window.fetch || !window.URLSearchParams) { if (already) window.location.assign(CODE_URL); else realPost(email, { u: CODE_URL }); return; }
          busy(g, true);
          if (!already) { lastEmail = email; signupOk = null; }
          var signup = already ? Promise.resolve(true) : subscribe(email).then(function (ok) {
            signupOk = ok;
            if (ok) setJoined();
            paint(lastCart);
            return ok;
          });
          codeFlow().then(function (res) {
            if (res.state === 'failed') {
              /* Rare: the background request couldn't add the code. Once the
                 sign-up has settled, let the browser add it on the way to /cart. */
              signup.then(function (ok) {
                if (ok) { window.location.assign(CODE_URL); return; }
                realPost(email, { u: CODE_URL });
              });
              return;
            }
            st = { state: res.state, code: res.code, other: res.other };
            keepAfterSwap();
            busy(g, false);
            if (res.cart) { lastCart = res.cart; lastAt = Date.now(); }
            document.querySelectorAll('[data-circle-banner][data-cb-guest]').forEach(function (el) { el.setAttribute('data-cb-just-joined', ''); });
            paint(lastCart);
            var Cart = window.TheColor && window.TheColor.Cart;
            if (Cart && typeof Cart.init === 'function') { try { Cart.init(); } catch (err) {} }
            try { document.dispatchEvent(new CustomEvent('tc:welcome15', { detail: { applied: res.state === 'on', kept: res.state === 'kept', code: res.code || null, from: 'basket' } })); } catch (err) { paint(lastCart); }
          });
        }
        document.addEventListener('click', function (e) {
          var t = e.target;
          var b = t.closest && t.closest('[data-cb-w15-go]');
          var g = b && b.closest('[data-cb-w15]');
          if (g) { e.preventDefault(); join(g); return; }
          var cf = t.closest && t.closest('[data-cb-w15-confirm-go]');
          if (cf && lastEmail) {
            e.preventDefault();
            if (cf.getAttribute('aria-busy') === 'true') return;
            cf.setAttribute('aria-busy', 'true');
            /* Try Klaviyo again first (no captcha); the real form only if
               that still doesn't go through. */
            klaviyoSub(lastEmail).then(function (ok) {
              cf.removeAttribute('aria-busy');
              if (ok) { signupOk = true; setJoined(); paint(lastCart); return; }
              realPost(lastEmail, { u: '/cart', k: 1 });
            });
          }
        });
        /* Enter in the email box must never submit the basket's own form. */
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-cb-w15-email]')) return;
          e.preventDefault();
          e.stopPropagation();
          var g = e.target.closest('[data-cb-w15]');
          if (g) join(g);
        }, true);
        document.addEventListener('input', function (e) {
          var i = e.target;
          if (!i.matches || !i.matches('[data-cb-w15-email]') || i.getAttribute('aria-invalid') !== 'true') return;
          var g = i.closest('[data-cb-w15]');
          if (g && RE.test(i.value.trim())) say(g, '');
        });
      })();

      /* Basket sign-up when 15% is already on (24 Oct 2026, journey audit).
         The row printed by snippets/circle-cart-points.liquid ([data-cb-on]):
         FIRST15 / WELCOME15 applied (usually by itself on a Google landing),
         one-off lines in the basket, not on our emails yet → "✓ Your 15% is
         on. Want Mel's hair tips?" opens an email box. Posts through the same
         sign-up as the row above (bot guard, Klaviyo list Y6RS7f, /contact
         alongside), custom_source "Basket FIRST15 on". Thank-you for 4 s, then
         the row folds away for good in this browser (cookie tc_subscribed,
         the one the pop-up and quiz set too). Delegated: the drawer re-renders. */
      (function () {
        if (window.__tcCbOn) return;
        window.__tcCbOn = true;
        var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        var BAD = 'Please enter a full email, e.g. name@example.com.';
        var FAIL = 'That didn’t go through. Please try again.';
        function joined() { return /(?:^|; )tc_subscribed=1(?:;|$)/.test(document.cookie); }
        function setJoined() {
          document.cookie = 'tc_subscribed=1; path=/; max-age=31536000; SameSite=Lax; Secure';
          document.documentElement.classList.add('tc-subscribed');
        }
        function firstOn(c) {
          return ((c && c.discount_codes) || []).some(function (d) {
            var k = String((d && d.code) || '').toUpperCase();
            return (k === 'FIRST15' || k === 'WELCOME15') && !!(d && d.applicable);
          });
        }
        function paint(c) {
          if (!c) return;
          var oneOff = (c.items || []).some(function (i) { return i && !i.selling_plan_allocation && !i.gift_card; });
          var show = c.item_count > 0 && oneOff && firstOn(c) && !joined();
          document.querySelectorAll('[data-cb-on]').forEach(function (el) {
            if (el.hasAttribute('data-cb-on-thanks')) return;
            el.hidden = !show;
          });
        }
        document.addEventListener('cart:updated', function (e) {
          var c = e && e.detail && e.detail.cart;
          if (c && Array.isArray(c.discount_codes)) paint(c);
        });
        function say(g, t) {
          var m = g.querySelector('[data-cb-on-msg]');
          var i = g.querySelector('[data-cb-on-email]');
          if (m) m.textContent = t || '';
          if (i) i.setAttribute('aria-invalid', t ? 'true' : 'false');
        }
        function thanks(row) {
          document.querySelectorAll('[data-cb-on]').forEach(function (el) {
            el.setAttribute('data-cb-on-thanks', '');
            var g = el.querySelector('[data-cb-on-group]');
            var d = el.querySelector('[data-cb-on-done]');
            if (g) g.hidden = true;
            if (d) d.textContent = '✓ Thank you, you’re on the list.';
          });
          setTimeout(function () {
            document.querySelectorAll('[data-cb-on]').forEach(function (el) {
              el.hidden = true;
              el.removeAttribute('data-cb-on-thanks');
            });
          }, 4000);
        }
        function join(row) {
          var g = row.querySelector('[data-cb-on-group]');
          var b = row.querySelector('[data-cb-on-go]');
          var input = row.querySelector('[data-cb-on-email]');
          if (!g || !b || g.getAttribute('aria-busy') === 'true') return;
          var email = input ? input.value.trim() : '';
          if (!RE.test(email)) { say(g, BAD); if (input) input.focus(); return; }
          say(g, '');
          var sub = window.__tcCbSubscribe;
          if (typeof sub !== 'function') { say(g, FAIL); return; }
          g.setAttribute('aria-busy', 'true');
          b.setAttribute('aria-busy', 'true');
          b.textContent = 'Joining…';
          if (input) input.readOnly = true;
          sub(email, 'Basket FIRST15 on', g).then(function (ok) {
            g.removeAttribute('aria-busy');
            b.removeAttribute('aria-busy');
            b.textContent = 'Yes please';
            if (input) input.readOnly = false;
            if (!ok) { say(g, FAIL); return; }
            setJoined();
            thanks(row);
          });
        }
        document.addEventListener('click', function (e) {
          var t = e.target;
          var tg = t.closest && t.closest('[data-cb-on-toggle]');
          if (tg) {
            var g = tg.closest('[data-cb-on-group]');
            var body = g && g.querySelector('[data-cb-on-body]');
            if (!body) return;
            var open = body.hidden;
            body.hidden = !open;
            tg.setAttribute('aria-expanded', open ? 'true' : 'false');
            g.classList.toggle('is-open', open);
            if (open) { var i = body.querySelector('[data-cb-on-email]'); if (i) { try { i.focus({ preventScroll: true }); } catch (err) {} } }
            return;
          }
          var go = t.closest && t.closest('[data-cb-on-go]');
          var row = go && go.closest('[data-cb-on]');
          if (row) { e.preventDefault(); join(row); }
        });
        /* Enter in the email box must never submit the basket's own form (/cart). */
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-cb-on-email]')) return;
          e.preventDefault();
          e.stopPropagation();
          var row = e.target.closest('[data-cb-on]');
          if (row) join(row);
        }, true);
        document.addEventListener('input', function (e) {
          var i = e.target;
          if (!i.matches || !i.matches('[data-cb-on-email]') || i.getAttribute('aria-invalid') !== 'true') return;
          var g = i.closest('[data-cb-on-group]');
          if (g && RE.test(i.value.trim())) say(g, '');
        });
      })();
